/**
 * Visual 20% Discount Display
 * ------------------------------
 * Pure front-end script — finds price elements on collection and product
 * pages, and rewrites them to show: original price (struck through) + new
 * discounted price. Does NOT change your actual Shopify prices or what's
 * charged at checkout — it's purely visual.
 *
 * IMPORTANT: pair this with a Shopify Automatic Discount (Admin > Discounts
 * > Create discount > Automatic discount, 20% off all products) so the
 * checkout total actually matches what customers see here. Otherwise this
 * is misleading. See setup-instructions.md for that step (no app needed).
 *
 * INSTALL:
 *   Assets > Add new asset > discount-display.js > paste this in.
 *   Add to theme.liquid before </body>:
 *     <script src="{{ 'discount-display.js' | asset_url }}" defer></script>
 *
 * CONFIG:
 *   Adjust PRICE_SELECTOR below to match your theme's price element.
 *   To find it: right-click a price on your site > Inspect > note the class.
 */

(function () {
  const DISCOUNT_PERCENT = 20;

  // Common Shopify theme price selectors — the script tries each until one
  // matches something on the page. Add your theme's specific class here if
  // none of these match (inspect a price element to find it).
  const PRICE_SELECTORS = [
    ".price-item--regular",
    ".price__regular .price-item",
    ".price .money",
    ".product-price",
    "[data-price]",
    ".money",
  ];

  function parsePrice(text) {
    // Strips currency symbols/commas, keeps digits and decimal point
    const cleaned = text.replace(/[^0-9.]/g, "");
    return parseFloat(cleaned);
  }

  function formatPrice(amount) {
    // Adjust currency symbol/format here if needed (default: Indian Rupee, no decimals)
    return "₹" + Math.round(amount).toLocaleString("en-IN");
  }

  function applyDiscountDisplay(el) {
    if (el.dataset.discountApplied) return; // avoid re-processing on repeated runs

    const originalText = el.textContent.trim();
    const originalPrice = parsePrice(originalText);
    if (!originalPrice || isNaN(originalPrice)) return;

    const discountedPrice = originalPrice * (1 - DISCOUNT_PERCENT / 100);

    el.dataset.discountApplied = "true";
    el.innerHTML = `
      <span style="text-decoration:line-through;color:#999;margin-right:8px;">
        ${formatPrice(originalPrice)}
      </span>
      <span style="color:#c98f8f;font-weight:600;">
        ${formatPrice(discountedPrice)}
      </span>
    `;
  }

  function run() {
    let found = 0;
    PRICE_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        applyDiscountDisplay(el);
        found++;
      });
    });

    if (found === 0) {
      console.warn(
        "[discount-display] No price elements matched. Inspect a price on " +
        "your site and add its class to PRICE_SELECTORS in discount-display.js"
      );
    }
  }

  document.addEventListener("DOMContentLoaded", run);

  // Collection pages / quick-view modals sometimes load prices dynamically
  // after initial page load — watch for new price elements being added.
  const observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });
})();